// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2k6qj","ranges":"BmiRanges_ranges__1JFHU"};